var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summernote"},[_c('div',{ref:"editor",staticClass:"summernote-editor"}),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"image/*","multiple":"","hidden":""},on:{"change":_vm.onFileChange}})])}
var staticRenderFns = []

export { render, staticRenderFns }